(function () {
  'use strict';

  var STORAGE_KEY = 'nmWholesaleSelection';
  var LANG_COOKIE = 'nm_wsc_lang';
  var currentLang = 'en';

  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  // ---------------------------------------------------------------------
  // Source tagging — a QR code (e.g. printed for a trade-show booth) can
  // link to the catalog page with ?src=canton-fair-2026; whichever page
  // loads first captures it into sessionStorage, so it survives the
  // catalog → inquiry navigation and rides along on the eventual submit.
  // ---------------------------------------------------------------------
  var SOURCE_KEY = 'nmWscSource';
  function captureSource() {
    try {
      var src = new URLSearchParams(window.location.search).get('src');
      if (src) sessionStorage.setItem(SOURCE_KEY, src);
    } catch (e) { /* ignore */ }
  }
  function getSource() {
    try { return sessionStorage.getItem(SOURCE_KEY) || ''; } catch (e) { return ''; }
  }

  // ---------------------------------------------------------------------
  // i18n — English stays whatever the merchant configured in the theme
  // editor (Liquid-rendered defaults); switching language overrides it
  // client-side with these translations. Product titles/descriptions and
  // the dynamic category pills (from Shopify product type) are NOT
  // translated — that's real catalog content, out of scope here.
  // ---------------------------------------------------------------------
  var I18N = {
    kicker: { es: 'Para empresas', fr: 'Pour les professionnels', hi: 'व्यवसायों के लिए', zh: '企业采购', ko: '기업 고객 전용', ja: '法人のお客様へ' },
    heading: { es: 'Explore y seleccione lo que le gustaría vender.', fr: 'Parcourez et sélectionnez ce que vous souhaitez vendre.', hi: 'ब्राउज़ करें और चुनें कि आप क्या स्टॉक करना चाहेंगे।', zh: '浏览并勾选您想要进货的商品。', ko: '취급하고 싶은 상품을 둘러보고 선택하세요.', ja: '取り扱いたい商品を選んでください。' },
    lead: { es: 'Toque los productos para ver fotos, videos y 3D, luego marque los que le interesen. Continúe para enviarnos su selección y nuestro equipo se pondrá en contacto con precios y cantidades mínimas.', fr: 'Touchez les produits pour voir les photos, vidéos et la 3D, puis cochez ceux qui vous intéressent. Continuez pour nous envoyer votre sélection et notre équipe vous recontactera avec les prix et les quantités minimales.', hi: 'उत्पादों की फ़ोटो, वीडियो और 3D देखने के लिए उन्हें टैप करें, फिर जिनमें रुचि है उन्हें चुनें। अपनी पसंद भेजने के लिए जारी रखें और हमारी टीम मूल्य और न्यूनतम ऑर्डर मात्रा के साथ संपर्क करेगी।', zh: '点击商品可查看照片、视频与 3D，勾选您感兴趣的商品后送出，我们的团队会尽快回复报价与最低订购量。', ko: '상품을 눌러 사진, 동영상, 3D를 확인한 뒤 관심 있는 상품을 선택하세요. 선택 내용을 보내주시면 팀에서 가격과 최소 주문 수량을 안내해 드립니다.', ja: '商品をタップして写真・動画・3Dをご確認いただき、気になる商品にチェックを入れてください。選択内容を送信いただくと、価格と最小注文数量についてご連絡いたします。' },
    related_label: { es: 'Buena elección — también le puede interesar', fr: 'Bon choix — vous aimerez peut-être aussi', hi: 'बढ़िया पसंद — आपको ये भी पसंद आ सकते हैं', zh: '不错的选择 — 您可能也会喜欢', ko: '좋은 선택이에요 — 이런 상품도 마음에 드실 거예요', ja: 'いい選択です — こちらもおすすめです' },
    all_categories: { es: 'Todo', fr: 'Tout', hi: 'सभी', zh: '全部', ko: '전체', ja: 'すべて' },
    selected: { es: 'seleccionado(s)', fr: 'sélectionné(s)', hi: 'चयनित', zh: '已选', ko: '개 선택됨', ja: '点選択中' },
    select_all: { es: 'Seleccionar todo', fr: 'Tout sélectionner', hi: 'सभी चुनें', zh: '全选', ko: '전체 선택', ja: 'すべて選択' },
    clear_all: { es: 'Deseleccionar todo', fr: 'Tout désélectionner', hi: 'सभी हटाएं', zh: '取消全选', ko: '전체 선택 해제', ja: '選択解除' },
    review_send: { es: 'Revisar y enviar consulta →', fr: 'Vérifier et envoyer la demande →', hi: 'समीक्षा करें और पूछताछ भेजें →', zh: '确认并送出询问 →', ko: '확인 후 문의 보내기 →', ja: '確認して問い合わせを送信 →' },
    view_3d: { es: 'Ver en 3D', fr: 'Voir en 3D', hi: '3D में देखें', zh: '查看 3D', ko: '3D로 보기', ja: '3Dで見る' },
    loading_3d: { es: 'Cargando visor 3D…', fr: 'Chargement de la vue 3D…', hi: '3D व्यूअर लोड हो रहा है…', zh: '3D 查看器加载中…', ko: '3D 뷰어 로딩 중…', ja: '3Dビューアーを読み込み中…' },
    select_product: { es: 'Seleccionar este producto', fr: 'Sélectionner ce produit', hi: 'यह उत्पाद चुनें', zh: '选择这项商品', ko: '이 제품 선택', ja: 'この商品を選択' },
    selected_product: { es: 'Seleccionado ✓ — toque para quitar', fr: 'Sélectionné ✓ — toucher pour retirer', hi: 'चयनित ✓ — हटाने के लिए टैप करें', zh: '已选 ✓ — 点击取消', ko: '선택됨 ✓ — 탭하여 제거', ja: '選択済み ✓ — タップで解除' },
    preview_sound: { es: 'Escuchar un adelanto', fr: 'Écouter un aperçu', hi: 'ध्वनि सुनें', zh: '试听音效', ko: '소리 미리듣기', ja: '音を試聴' },
    no_products: { es: 'Todavía no hay productos en esta colección.', fr: 'Aucun produit dans cette collection pour le moment.', hi: 'इस संग्रह में अभी कोई उत्पाद नहीं है।', zh: '这个系列目前没有商品。', ko: '이 컬렉션에는 아직 상품이 없습니다.', ja: 'このコレクションにはまだ商品がありません。' },
    back_to_catalog: { es: 'Volver al catálogo', fr: 'Retour au catalogue', hi: 'कैटलॉग पर वापस जाएं', zh: '返回选品目录', ko: '카탈로그로 돌아가기', ja: 'カタログに戻る' },
    your_selection: { es: 'Su selección', fr: 'Votre sélection', hi: 'आपका चयन', zh: '您的已选商品', ko: '선택한 상품', ja: '選択した商品' },
    no_products_selected: { es: 'Aún no ha seleccionado ningún producto.', fr: "Aucun produit sélectionné pour l'instant.", hi: 'अभी तक कोई उत्पाद नहीं चुना गया।', zh: '尚未选择任何商品。', ko: '아직 선택한 상품이 없습니다.', ja: 'まだ商品が選択されていません。' },
    browse_catalog: { es: 'Explorar el catálogo →', fr: 'Parcourir le catalogue →', hi: 'कैटलॉग ब्राउज़ करें →', zh: '浏览选品目录 →', ko: '카탈로그 둘러보기 →', ja: 'カタログを見る →' },
    get_in_touch: { es: 'Contáctenos', fr: 'Contactez-nous', hi: 'संपर्क करें', zh: '联系我们', ko: '문의하기', ja: 'お問い合わせ' },
    send_your_selection: { es: 'Enviar su selección', fr: 'Envoyer votre sélection', hi: 'अपना चयन भेजें', zh: '送出您的选品', ko: '선택 상품 보내기', ja: '選択内容を送信' },
    form_text: { es: 'Agregue sus datos de contacto y le responderemos pronto con precios y los próximos pasos.', fr: "Ajoutez vos coordonnées et nous vous répondrons rapidement avec les prix et les prochaines étapes.", hi: 'अपनी संपर्क जानकारी जोड़ें और हम जल्द ही मूल्य निर्धारण और अगले कदमों के साथ आपसे संपर्क करेंगे।', zh: '留下您的联系方式，我们会尽快回复报价与后续事宜。', ko: '연락처를 남겨주시면 곧 가격과 다음 단계를 안내해 드리겠습니다.', ja: 'ご連絡先をご入力いただければ、価格と今後の流れについて折り返しご連絡いたします。' },
    company_name: { es: 'Nombre de la empresa', fr: "Nom de l'entreprise", hi: 'कंपनी का नाम', zh: '公司名称', ko: '회사명', ja: '会社名' },
    contact_name: { es: 'Nombre de contacto', fr: 'Nom du contact', hi: 'संपर्क व्यक्ति का नाम', zh: '联系人姓名', ko: '담당자 이름', ja: 'ご担当者名' },
    country: { es: 'País', fr: 'Pays', hi: 'देश', zh: '国家/地区', ko: '국가', ja: '国' },
    phone_whatsapp: { es: 'Teléfono / WhatsApp', fr: 'Téléphone / WhatsApp', hi: 'फ़ोन / व्हाट्सएप', zh: '电话 / WhatsApp', ko: '전화 / WhatsApp', ja: '電話番号 / WhatsApp' },
    est_quantity: { es: 'Cantidad estimada de compra', fr: 'Quantité estimée', hi: 'अनुमानित मात्रा', zh: '预估采购数量', ko: '예상 구매 수량', ja: 'ご希望の数量' },
    est_quantity_placeholder: { es: 'ej. 100 unidades', fr: 'ex. 100 unités', hi: 'उदा. 100 यूनिट', zh: '例如：100 件', ko: '예: 100개', ja: '例：100個' },
    email: { es: 'Correo electrónico', fr: 'E-mail', hi: 'ईमेल', zh: '电子邮件', ko: '이메일', ja: 'メールアドレス' },
    anything_else: { es: '¿Algo más que debamos saber?', fr: 'Autre chose à savoir ?', hi: 'कुछ और बताना चाहेंगे?', zh: '还有什么想告诉我们的吗？', ko: '추가로 알려주실 내용이 있나요?', ja: 'その他ご要望があればご記入ください' },
    notes_placeholder: { es: 'Tamaño del pedido, plazos, etc.', fr: 'Taille de commande, délai, etc.', hi: 'ऑर्डर आकार, समयसीमा, आदि।', zh: '订购量、时程等', ko: '주문 규모, 일정 등', ja: '注文数量やご希望のスケジュールなど' },
    phone_code_label: { es: 'Código', fr: 'Indicatif', hi: 'कोड', zh: '国码', ko: '국가번호', ja: '国番号' },
    send_inquiry: { es: 'Enviar consulta', fr: 'Envoyer la demande', hi: 'पूछताछ भेजें', zh: '送出询问', ko: '문의 보내기', ja: '問い合わせを送信' },
    sending: { es: 'Enviando…', fr: 'Envoi en cours…', hi: 'भेजा जा रहा है…', zh: '送出中…', ko: '전송 중…', ja: '送信中…' },
    success_heading: { es: '¡Gracias — lo hemos recibido!', fr: "Merci — c'est bien reçu !", hi: 'धन्यवाद — हमें मिल गया!', zh: '谢谢 — 我们收到了！', ko: '감사합니다 — 접수되었습니다!', ja: 'ありがとうございます — 受け付けました！' },
    success_text: { es: 'Alguien de nuestro equipo se pondrá en contacto pronto por correo electrónico con precios y próximos pasos.', fr: "Un membre de notre équipe vous contactera bientôt par e-mail avec les prix et les prochaines étapes.", hi: 'हमारी टीम का एक सदस्य जल्द ही ईमेल द्वारा मूल्य निर्धारण और अगले कदमों के साथ आपसे संपर्क करेगा।', zh: '我们的团队会尽快通过 email 与您联系，说明报价与后续步骤。', ko: '팀원이 곧 이메일로 가격과 다음 단계를 안내해 드리겠습니다.', ja: '担当者より近日中にメールにて価格と今後の流れをご案内いたします。' },
    error_text: { es: 'Lo sentimos, ocurrió un problema al enviar su consulta — inténtelo de nuevo o escríbanos directamente.', fr: "Désolé, une erreur s'est produite lors de l'envoi de votre demande — veuillez réessayer ou nous écrire directement.", hi: 'क्षमा करें, आपकी पूछताछ भेजने में कुछ गड़बड़ हो गई — कृपया पुनः प्रयास करें या हमें सीधे ईमेल करें।', zh: '抱歉，送出询问时发生问题，请再试一次，或直接给我们发邮件。', ko: '죄송합니다. 문의 전송 중 문제가 발생했습니다 — 다시 시도하시거나 직접 이메일로 문의해 주세요.', ja: '申し訳ございません、送信中にエラーが発生しました。もう一度お試しいただくか、直接メールにてご連絡ください。' },
  };

  /** Returns the translation for `key` in the current language, or null to mean "leave the
      Liquid/merchant-authored English text alone" (currentLang === 'en', or no translation). */
  function t(key) {
    var entry = I18N[key];
    if (!entry || currentLang === 'en') return null;
    return entry[currentLang] || null;
  }

  /** Applies (or un-applies) translations. Stashes each element's original Liquid/merchant-
      authored English text the first time it's touched, in a data-i18n-orig[-ph] attribute, so
      switching back to English restores it instead of leaving the last language's text stuck —
      t() returning null for English isn't enough on its own once the text has been overwritten. */
  function applyStaticI18n() {
    document.querySelectorAll('[data-i18n]').forEach(function (el) {
      if (el.getAttribute('data-i18n-orig') === null) el.setAttribute('data-i18n-orig', el.textContent);
      if (currentLang === 'en') {
        el.textContent = el.getAttribute('data-i18n-orig');
      } else {
        var val = t(el.getAttribute('data-i18n'));
        if (val != null) el.textContent = val;
      }
    });
    document.querySelectorAll('[data-i18n-placeholder]').forEach(function (el) {
      if (el.getAttribute('data-i18n-ph-orig') === null) el.setAttribute('data-i18n-ph-orig', el.getAttribute('placeholder') || '');
      if (currentLang === 'en') {
        el.setAttribute('placeholder', el.getAttribute('data-i18n-ph-orig'));
      } else {
        var phVal = t(el.getAttribute('data-i18n-placeholder'));
        if (phVal != null) el.setAttribute('placeholder', phVal);
      }
    });
  }

  /** Wires the <select id="nm-wsc-lang"> in the top bar and the first-visit language gate
      (present on both pages), applying the saved/chosen language to every [data-i18n] element.
      Call once, before initCatalog/initInquiryForm read any button's initial text.
      Language choice is stored in a cookie (not localStorage) so it's shared across the catalog
      and inquiry pages the same way, and survives the way the merchant expects "remembered". */
  function initLangSwitcher() {
    currentLang = getCookie(LANG_COOKIE) || 'en';
    var sel = document.getElementById('nm-wsc-lang');
    if (sel) sel.value = currentLang;

    function setLang(lang) {
      currentLang = lang;
      setCookie(LANG_COOKIE, lang, 365);
      if (sel) sel.value = lang;
      applyStaticI18n();
    }

    if (sel) sel.addEventListener('change', function () { setLang(sel.value); });

    applyStaticI18n();

    // First-visit gate: ask before defaulting to English, only when no choice is on record yet.
    var gate = document.getElementById('nm-wsc-lang-gate');
    if (gate && !getCookie(LANG_COOKIE)) {
      gate.classList.add('nm-show');
      gate.querySelectorAll('[data-lang]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          setLang(btn.getAttribute('data-lang'));
          gate.classList.remove('nm-show');
        });
      });
    }
  }

  function loadSelection() {
    try {
      var saved = sessionStorage.getItem(STORAGE_KEY);
      if (saved) return JSON.parse(saved);
    } catch (e) { /* ignore */ }
    return {};
  }

  function saveSelection(selected) {
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(selected)); } catch (e) { /* ignore */ }
  }

  // ---------------------------------------------------------------------
  // Catalog page: grid, filter pills, checkboxes, sticky bar, quick view
  // ---------------------------------------------------------------------
  function initCatalog() {
    var root = document.querySelector('.nm-wsc');
    var grid = root && root.querySelector('.nm-wsc-grid');
    if (!root || !grid) return;

    var cards = Array.prototype.slice.call(root.querySelectorAll('.nm-wsc-card'));
    var bar = root.querySelector('.nm-wsc-bar');
    var barCount = root.querySelector('.nm-wsc-bar-count b');
    var toolbarCount = root.querySelector('.nm-wsc-count b');
    var selectAllBtn = root.querySelector('.nm-wsc-selectall');
    var pills = Array.prototype.slice.call(root.querySelectorAll('.nm-wsc-pill'));
    var modal = root.querySelector('.nm-wsc-modal');
    var modal3d = root.querySelector('.nm-wsc-3d-modal');
    var stage3d = modal3d && modal3d.querySelector('.nm-wsc-3d-stage');

    function close3d() {
      if (!modal3d) return;
      modal3d.classList.remove('nm-show');
      if (stage3d) stage3d.innerHTML = '';
    }

    // model-viewer.min.js (~935KB) is only fetched the first time someone actually taps
    // "View in 3D" — most catalog visitors never open a 3D model, and this is real weight to
    // avoid loading unconditionally on slow/congested wifi (e.g. a trade-show booth).
    var mvScriptState = 'idle'; // idle | loading | loaded
    var mvWaiters = [];
    function ensureModelViewer(cb) {
      if (mvScriptState === 'loaded') { cb(); return; }
      mvWaiters.push(cb);
      if (mvScriptState === 'loading') return;
      var src = modal3d && modal3d.getAttribute('data-mv-src');
      if (!src) { mvWaiters.forEach(function (fn) { fn(); }); mvWaiters = []; return; }
      mvScriptState = 'loading';
      var script = document.createElement('script');
      script.type = 'module';
      script.src = src;
      function done() {
        mvScriptState = 'loaded';
        mvWaiters.forEach(function (fn) { fn(); });
        mvWaiters = [];
      }
      script.onload = done;
      script.onerror = done; // fail open — render() below just won't have a defined element
      document.head.appendChild(script);
    }

    function open3d(model) {
      if (!modal3d || !stage3d || !model || !model.src) return;
      stage3d.innerHTML = '<p style="padding:40px;text-align:center;color:#5F757A;">' + (t('loading_3d') || 'Loading 3D viewer…') + '</p>';
      modal3d.classList.add('nm-show');

      function render() {
        stage3d.innerHTML = '<model-viewer src="' + model.src + '" ar camera-controls auto-rotate ' +
          (model.preview ? 'poster="' + model.preview + '"' : '') + ' style="width:100%;height:100%;"></model-viewer>';
      }
      ensureModelViewer(function () {
        // model-viewer.min.js registers its custom element asynchronously; wait for that too,
        // so a fast tap right after the script loads doesn't render an inert, invisible tag.
        if (window.customElements && customElements.whenDefined) {
          customElements.whenDefined('model-viewer').then(render).catch(render);
        } else {
          render();
        }
      });
    }

    if (modal3d) {
      var close3dBtn = modal3d.querySelector('.nm-wsc-3d-close');
      if (close3dBtn) close3dBtn.addEventListener('click', close3d);
      modal3d.addEventListener('click', function (e) { if (e.target === modal3d) close3d(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close3d(); });
    }

    var selected = loadSelection();

    function count() { return Object.keys(selected).length; }

    function syncCardVisual(card) {
      var handle = card.getAttribute('data-handle');
      card.classList.toggle('nm-wsc-checked', !!selected[handle]);
    }

    function refreshUI() {
      var n = count();
      if (barCount) barCount.textContent = n;
      if (toolbarCount) toolbarCount.textContent = n;
      if (bar) bar.classList.toggle('nm-show', n > 0);
      cards.forEach(syncCardVisual);
      var modalBtn = modal && modal.querySelector('.nm-wsc-modal-select');
      var openHandle = modal && modal.getAttribute('data-open-handle');
      if (modalBtn && modal.classList.contains('nm-show')) {
        setModalSelectState(modalBtn, !!selected[openHandle]);
      }
      if (modal) {
        var relatedWrap = modal.querySelector('.nm-wsc-modal-related');
        if (relatedWrap) relatedWrap.classList.toggle('nm-show', !!selected[openHandle]);
        modal.querySelectorAll('.nm-wsc-related-item').forEach(function (el) {
          el.classList.toggle('nm-wsc-checked', !!selected[el.getAttribute('data-handle')]);
        });
      }
    }

    function cardImage(card) {
      var img = card.querySelector('.nm-wsc-art img');
      return img ? img.src : '';
    }

    function toggle(handle, title, url, image, category) {
      if (selected[handle]) {
        delete selected[handle];
      } else {
        selected[handle] = { title: title, url: url, qty: 1, image: image || '', category: category || '' };
      }
      saveSelection(selected);
      refreshUI();
    }

    cards.forEach(function (card) {
      var handle = card.getAttribute('data-handle');
      var title = card.getAttribute('data-title') || '';
      var url = card.getAttribute('data-url') || '';
      var category = card.getAttribute('data-type') || '';
      var checkBtn = card.querySelector('.nm-wsc-check');
      if (checkBtn) {
        checkBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          toggle(handle, title, url, cardImage(card), category);
        });
      }
      // Whole card opens the quick view (checkBtn.click above stops propagation so the
      // checkmark itself still just toggles selection instead of also opening the modal).
      card.style.cursor = 'pointer';
      card.addEventListener('click', function () { openModal(card); });
      syncCardVisual(card);
    });

    if (selectAllBtn) {
      selectAllBtn.addEventListener('click', function () {
        var visible = cards.filter(function (c) { return c.style.display !== 'none'; });
        var allSelected = visible.length > 0 && visible.every(function (c) { return !!selected[c.getAttribute('data-handle')]; });
        visible.forEach(function (c) {
          var handle = c.getAttribute('data-handle');
          if (allSelected) {
            delete selected[handle];
          } else if (!selected[handle]) {
            selected[handle] = { title: c.getAttribute('data-title') || '', url: c.getAttribute('data-url') || '', qty: 1, image: cardImage(c), category: c.getAttribute('data-type') || '' };
          }
        });
        saveSelection(selected);
        refreshUI();
        selectAllBtn.textContent = allSelected ? (t('select_all') || 'Select all') : (t('clear_all') || 'Clear all');
      });
    }

    // ---- Category filter pills ----
    if (pills.length) {
      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          pills.forEach(function (p) { p.classList.remove('nm-active'); });
          pill.classList.add('nm-active');
          var filter = pill.getAttribute('data-filter') || '';
          cards.forEach(function (card) {
            var type = card.getAttribute('data-type') || '';
            card.style.display = (!filter || type === filter) ? '' : 'none';
          });
          if (selectAllBtn) selectAllBtn.textContent = t('select_all') || 'Select all';
        });
      });
    }

    // ---- Quick-view modal ----
    function setModalSelectState(btn, isOn) {
      btn.classList.toggle('nm-wsc-checked', isOn);
      btn.textContent = isOn ? (t('selected_product') || 'Selected ✓ — tap to remove') : (t('select_product') || 'Select this product');
    }

    function renderDesc(wrap, raw) {
      wrap.innerHTML = '';
      var parts = (raw || '').split(/\s*-\s*/).map(function (s) { return s.trim(); }).filter(Boolean);
      if (parts.length > 1) {
        var ul = document.createElement('ul');
        parts.forEach(function (p) {
          var li = document.createElement('li');
          li.textContent = p;
          ul.appendChild(li);
        });
        wrap.appendChild(ul);
      } else if (raw) {
        var p = document.createElement('p');
        p.textContent = raw;
        wrap.appendChild(p);
      }
    }

    function renderVariants(wrap, raw, onPick) {
      wrap.innerHTML = '';
      var options = [];
      try { options = JSON.parse(raw || '[]'); } catch (e) { options = []; }
      options.forEach(function (opt) {
        var row = document.createElement('div');
        row.className = 'nm-wsc-variant-row';
        var label = document.createElement('b');
        label.textContent = opt.name + ':';
        row.appendChild(label);
        var pillWrap = document.createElement('div');
        pillWrap.className = 'nm-wsc-variant-pills';
        (opt.values || []).forEach(function (v, i) {
          var pill = document.createElement('button');
          pill.type = 'button';
          pill.className = 'nm-wsc-variant-pill' + (i === 0 ? ' nm-active' : '');
          pill.textContent = v.value;
          pill.addEventListener('click', function () {
            pillWrap.querySelectorAll('.nm-wsc-variant-pill').forEach(function (p) { p.classList.remove('nm-active'); });
            pill.classList.add('nm-active');
            if (v.mediaId) onPick(v.mediaId);
          });
          pillWrap.appendChild(pill);
        });
        row.appendChild(pillWrap);
        wrap.appendChild(row);
      });
    }

    function openModal(card) {
      if (!modal) return;
      var handle = card.getAttribute('data-handle');
      var title = card.getAttribute('data-title') || '';
      var url = card.getAttribute('data-url') || '';
      var price = card.getAttribute('data-price') || '';
      var desc = card.getAttribute('data-desc') || '';
      var mediaRaw = card.getAttribute('data-media');
      var variantsRaw = card.getAttribute('data-variants');
      var model3dRaw = card.getAttribute('data-3d');
      var media = [];
      var model3d = null;
      try { media = JSON.parse(mediaRaw || '[]'); } catch (e) { media = []; }
      try { model3d = model3dRaw ? JSON.parse(model3dRaw) : null; } catch (e) { model3d = null; }

      var view3dBtn = modal.querySelector('.nm-wsc-view3d');
      if (view3dBtn) {
        if (model3d && model3d.src) {
          view3dBtn.style.display = '';
          view3dBtn.onclick = function () { open3d(model3d); };
        } else {
          view3dBtn.style.display = 'none';
          view3dBtn.onclick = null;
        }
      }

      // Audio preview, when the product has one (Products → metafields.custom.audio_preview).
      // The /^https?:\/\// check is a safety net: if Liquid ever renders a non-URL string into
      // data-audio again (e.g. a filter-on-nil error string), this treats it as "no audio"
      // instead of showing a button that plays nothing.
      var audioRawAttr = card.getAttribute('data-audio');
      var audioRaw = audioRawAttr && /^https?:\/\//.test(audioRawAttr) ? audioRawAttr : '';
      var audioBtn = modal.querySelector('.nm-wsc-audio-btn');
      var audioEl = modal.querySelector('.nm-wsc-audio-el');
      if (audioBtn && audioEl) {
        audioEl.pause();
        audioEl.currentTime = 0;
        audioBtn.classList.remove('nm-playing');
        if (audioRaw) {
          audioBtn.style.display = '';
          audioEl.src = audioRaw;
          audioBtn.onclick = function () {
            if (audioEl.paused) { audioEl.play().catch(function () {}); audioBtn.classList.add('nm-playing'); }
            else { audioEl.pause(); audioBtn.classList.remove('nm-playing'); }
          };
        } else {
          audioBtn.style.display = 'none';
          audioBtn.onclick = null;
          audioEl.removeAttribute('src');
        }
      }

      modal.setAttribute('data-open-handle', handle);
      modal.querySelector('.nm-wsc-modal-info h3').textContent = title;
      var priceEl = modal.querySelector('.nm-wsc-modal-info .nm-wsc-price');
      if (priceEl) priceEl.textContent = price;
      var descEl = modal.querySelector('.nm-wsc-modal-desc');
      if (descEl) renderDesc(descEl, desc);

      var mediaWrap = modal.querySelector('.nm-wsc-modal-media');
      var thumbsWrap = modal.querySelector('.nm-wsc-modal-thumbs');
      mediaWrap.innerHTML = '';
      thumbsWrap.innerHTML = '';

      var current = 0;

      function goTo(i) {
        current = i;
        mediaWrap.querySelectorAll('.nm-wsc-modal-item').forEach(function (el, idx) { el.classList.toggle('nm-on', idx === i); });
        thumbsWrap.querySelectorAll('.nm-wsc-modal-thumb').forEach(function (el, idx) { el.classList.toggle('nm-active', idx === i); });
      }

      function goToMediaId(mediaId) {
        for (var i = 0; i < media.length; i++) {
          if (String(media[i].mediaId) === String(mediaId)) { goTo(i); return; }
        }
      }

      if (media.length === 0) {
        var fallbackImg = card.querySelector('img');
        mediaWrap.innerHTML = '<div class="nm-wsc-modal-item nm-on"><img src="' + (fallbackImg ? fallbackImg.src : '') + '" alt=""></div>';
      } else {
        media.forEach(function (m, i) {
          var item = document.createElement('div');
          item.className = 'nm-wsc-modal-item' + (i === 0 ? ' nm-on' : '');
          if (m.type === 'video') {
            item.innerHTML = '<video controls playsinline preload="none" poster="' + (m.preview || '') + '">' +
              '<source src="' + m.src + '" type="video/mp4"></video>';
          } else {
            item.innerHTML = '<img src="' + m.src + '" alt="' + (m.alt || '').replace(/"/g, '&quot;') + '">';
          }
          mediaWrap.appendChild(item);

          var thumb = document.createElement('button');
          thumb.type = 'button';
          thumb.className = 'nm-wsc-modal-thumb' + (i === 0 ? ' nm-active' : '');
          var thumbImg = m.preview || (m.type === 'image' ? m.src : '');
          thumb.innerHTML = (thumbImg ? '<img src="' + thumbImg + '" alt="">' : '') +
            (m.type !== 'image' ? '<span class="nm-wsc-thumb-ico">' + (m.type === 'video'
              ? '<svg viewBox="0 0 24 24" fill="currentColor"><polygon points="6 4 20 12 6 20 6 4"/></svg>'
              : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2 2 7l10 5 10-5-10-5Z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>') + '</span>' : '');
          thumb.addEventListener('click', function () { goTo(i); });
          thumbsWrap.appendChild(thumb);
        });
      }
      thumbsWrap.style.display = media.length > 1 ? 'flex' : 'none';

      // Swipe left/right on the main media area to move between photos/video/3D.
      (function () {
        var startX = null, startY = null;
        mediaWrap.addEventListener('touchstart', function (e) {
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
        }, { passive: true });
        mediaWrap.addEventListener('touchend', function (e) {
          if (startX === null || media.length < 2) return;
          var dx = e.changedTouches[0].clientX - startX;
          var dy = e.changedTouches[0].clientY - startY;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
            var next = current + (dx < 0 ? 1 : -1);
            if (next >= 0 && next < media.length) goTo(next);
          }
          startX = null;
        });
      })();

      var variantsEl = modal.querySelector('.nm-wsc-modal-variants');
      if (variantsEl) renderVariants(variantsEl, variantsRaw, goToMediaId);

      var cardImg = cardImage(card);
      var cardCategory = card.getAttribute('data-type') || '';
      var selectBtn = modal.querySelector('.nm-wsc-modal-select');
      setModalSelectState(selectBtn, !!selected[handle]);
      selectBtn.onclick = function () { toggle(handle, title, url, cardImg, cardCategory); };

      // "You may also like" — populated fresh per product, shown once this one is selected.
      var relatedRaw = card.getAttribute('data-related');
      var related = [];
      try { related = JSON.parse(relatedRaw || '[]'); } catch (e) { related = []; }
      var relatedList = modal.querySelector('.nm-wsc-related-list');
      if (relatedList) {
        relatedList.innerHTML = '';
        related.forEach(function (r) {
          var item = document.createElement('div');
          item.className = 'nm-wsc-related-item';
          item.setAttribute('data-handle', r.handle);
          item.innerHTML = '<img src="' + r.image + '" alt="">' +
            '<span>' + r.title + '</span>' +
            '<button type="button" aria-label="Add ' + r.title.replace(/"/g, '&quot;') + '">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>' +
            '</button>';
          // Tapping the image/name opens that product's own full preview (same quick-view
          // modal, re-opened for the matching card in the grid); the little check button
          // stays a one-tap add without leaving the current preview.
          item.addEventListener('click', function () {
            var relatedCard = root.querySelector('.nm-wsc-card[data-handle="' + r.handle + '"]');
            if (relatedCard) openModal(relatedCard);
          });
          item.querySelector('button').addEventListener('click', function (e) {
            e.stopPropagation();
            toggle(r.handle, r.title, r.url, r.image, r.category);
          });
          relatedList.appendChild(item);
        });
      }

      modal.classList.add('nm-show');
      document.body.style.overflow = 'hidden';
      refreshUI();
    }

    function closeModal() {
      if (!modal) return;
      modal.classList.remove('nm-show');
      document.body.style.overflow = '';
      modal.querySelectorAll('video').forEach(function (v) { v.pause(); });
      var audioEl = modal.querySelector('.nm-wsc-audio-el');
      var audioBtn = modal.querySelector('.nm-wsc-audio-btn');
      if (audioEl) audioEl.pause();
      if (audioBtn) audioBtn.classList.remove('nm-playing');
      close3d();
    }

    if (modal) {
      var closeBtn = modal.querySelector('.nm-wsc-modal-close');
      if (closeBtn) closeBtn.addEventListener('click', closeModal);
      modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
    }

    refreshUI();
  }

  // ---------------------------------------------------------------------
  // Inquiry page: cart-style rows (image, clickable title, remove — no
  // quantity control, that's discussed after the team follows up) synced
  // to sessionStorage, a phone/WhatsApp country-code picker, and posting
  // the whole thing as JSON to the agent backend on submit.
  // ---------------------------------------------------------------------
  function initInquiryForm() {
    var listWrap = document.getElementById('nm-wsc-form-selected');
    if (!listWrap) return;

    var emptyMsg = document.getElementById('nm-wsc-form-empty');
    var submitBtn = document.getElementById('nm-wsc-submit');
    var selected = loadSelection();

    // Standalone enquiry page (no catalog selection step): visitors land here directly, so
    // an empty selection is normal and must not disable the submit button.
    var inquiryForm = document.getElementById('nm-wholesale-catalog-form');
    var requireSelection =
      !inquiryForm || inquiryForm.getAttribute('data-require-selection') !== 'false';

    // ---- Mini preview: image + name only, tapped from a cart row's product name ----
    var miniModal = document.getElementById('nm-wsc-mini-modal');
    var miniImg = document.getElementById('nm-wsc-mini-img');
    var miniTitle = document.getElementById('nm-wsc-mini-title');
    function openMiniPreview(item) {
      if (!miniModal) return;
      if (miniImg) miniImg.src = item.image || '';
      if (miniTitle) miniTitle.textContent = item.title || '';
      miniModal.classList.add('nm-show');
    }
    function closeMiniPreview() {
      if (miniModal) miniModal.classList.remove('nm-show');
    }
    if (miniModal) {
      var miniCloseBtn = miniModal.querySelector('.nm-wsc-mini-close');
      if (miniCloseBtn) miniCloseBtn.addEventListener('click', closeMiniPreview);
      miniModal.addEventListener('click', function (e) { if (e.target === miniModal) closeMiniPreview(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMiniPreview(); });
    }

    // ---- Collapse toggle (mobile only, via CSS) — open by default each page load ----
    var toggleBtn = document.getElementById('nm-wsc-cart-toggle');
    if (toggleBtn) {
      toggleBtn.addEventListener('click', function () {
        var expanded = toggleBtn.getAttribute('aria-expanded') !== 'false';
        toggleBtn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        listWrap.classList.toggle('nm-collapsed', expanded);
      });
    }

    function renderCartRows() {
      var handles = Object.keys(selected);
      listWrap.innerHTML = '';
      if (emptyMsg) emptyMsg.style.display = handles.length ? 'none' : '';
      if (toggleBtn) toggleBtn.style.display = handles.length ? '' : 'none';
      if (submitBtn && requireSelection) submitBtn.disabled = handles.length === 0;
      handles.forEach(function (h) {
        var item = selected[h];
        var safeTitle = (item.title || '').replace(/"/g, '&quot;');
        var row = document.createElement('div');
        row.className = 'nm-wsc-cart-row';
        row.innerHTML =
          '<img src="' + (item.image || '') + '" alt="">' +
          '<button type="button" class="nm-wsc-cart-title">' + item.title + '</button>' +
          '<button type="button" class="nm-wsc-cart-remove" aria-label="Remove ' + safeTitle + '">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"/></svg>' +
          '</button>';
        row.querySelector('.nm-wsc-cart-title').addEventListener('click', function () { openMiniPreview(item); });
        row.querySelector('.nm-wsc-cart-remove').addEventListener('click', function () {
          delete selected[h];
          saveSelection(selected);
          renderCartRows();
        });
        listWrap.appendChild(row);
      });
    }

    renderCartRows();

    // ---- Phone / WhatsApp: country code + number, merged when we build the payload ----
    var codeSelect = document.getElementById('nm-wsc-phone-code');
    var numberInput = document.getElementById('nm-wsc-phone-number');
    var customCodeInput = document.getElementById('nm-wsc-phone-custom-code');
    if (codeSelect) {
      codeSelect.addEventListener('change', function () {
        if (customCodeInput) customCodeInput.style.display = codeSelect.value === 'other' ? '' : 'none';
      });
    }
    function phoneValue() {
      var code = codeSelect ? (codeSelect.value === 'other' ? (customCodeInput ? customCodeInput.value.trim() : '') : codeSelect.value) : '';
      var number = numberInput ? numberInput.value.trim() : '';
      return number ? (code ? code + ' ' + number : number) : '';
    }

    // ---- Submit: post JSON straight to the agent backend (email + DingTalk) ----
    var form = document.getElementById('nm-wholesale-catalog-form');
    var errorBox = document.getElementById('nm-wsc-form-error');
    var successBox = document.getElementById('nm-wsc-form-success');
    var originalSubmitText = submitBtn ? submitBtn.textContent : (t('send_inquiry') || 'Send inquiry');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (errorBox) { errorBox.style.display = 'none'; errorBox.textContent = ''; }

        var products = Object.keys(selected).map(function (h) {
          var item = selected[h];
          return { title: item.title, qty: item.qty || 1, url: item.url, category: item.category || '' };
        });
        var payload = {
          company: (document.getElementById('nm-wsc-company') || {}).value || '',
          contactName: (document.getElementById('nm-wsc-contact-name') || {}).value || '',
          country: (document.getElementById('nm-wsc-country') || {}).value || '',
          phone: phoneValue(),
          estQuantity: (document.getElementById('nm-wsc-est-qty') || {}).value || '',
          email: (document.getElementById('nm-wsc-email') || {}).value || '',
          notes: (document.getElementById('nm-wsc-notes') || {}).value || '',
          products: products,
          campaign: getSource(),
        };

        var apiUrl = form.getAttribute('data-api-url');
        if (!apiUrl) return;

        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = t('sending') || 'Sending…'; }

        fetch(apiUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        })
          .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
          .then(function (result) {
            if (result.ok && result.data && result.data.ok) {
              form.style.display = 'none';
              if (successBox) successBox.style.display = '';
              try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) { /* ignore */ }
            } else {
              throw new Error((result.data && result.data.error) || 'request_failed');
            }
          })
          .catch(function () {
            if (errorBox) {
              errorBox.textContent = t('error_text') || "Sorry, something went wrong sending your inquiry — please try again, or email us directly.";
              errorBox.style.display = '';
            }
            if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalSubmitText; }
          });
      });
    }
  }

  function init() {
    captureSource();
    initLangSwitcher();
    initCatalog();
    initInquiryForm();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
